import axios from 'axios';

export const athletePrintASICard = (player) => {

    return axios({
        url: process.env.REACT_APP_API_EMP,
        method: 'post',
        data: {
            operationName: 'athletePrintASICard',
            variables: { id: player._id, code: player.asi_athlete_card_code },
            query: `query athletePrintASICard($id: String!, $code: String!) {
                athletePrintASICard(id: $id, code: $code) {
                    filename
                    content
                    __typename
                }
            }`
        },
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 60000
    })
}

export const athletePrintAICSCard = (player) => {

    return axios({
        url: process.env.REACT_APP_API_EMP,
        method: 'post',
        data: {
            operationName: 'athletePrintAICSCard',
            variables: { id: player._id, code: player.aics_card_number },
            query: `query athletePrintAICSCard($id: String!, $code: String!) {
                athletePrintAICSCard(id: $id, code: $code) {
                    filename
                    content
                    __typename
                }
            }`
        },
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 60000
    })
}

export const createPIXCharge = (input) => {
    return axios({
        url: process.env.REACT_APP_API_EMP,
        method: 'post',
        data: {
            operationName: 'createPIXCharge',
            variables: input,
            query: `mutation createPIXCharge($input: PIXChargeInput!) {
                createPIXCharge(input: $input) {
                    charge_id
                    value
                    qr_code
                    qr_code_base64
                    link
                    is_expired
                    expiration
                    status
                    __typename
                }
            }`
        },
        headers: {
            'Content-Type': 'application/json',
        },
        timeout: 60000
    });
}
